import { Icon, IconProps } from '@chakra-ui/react'

export function CreditCardIcon(props: IconProps) {
  return (
    <Icon viewBox="0 0 25 19" {...props}>
      <svg width="25" height="19" viewBox="0 0 25 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M23.0319 7.33366H1.36523M11.1152 11.667H5.69857M1.36523 5.38366L1.36523 13.617C1.36523 14.8304 1.36523 15.4372 1.60139 15.9006C1.80911 16.3083 2.14057 16.6398 2.54825 16.8475C3.01173 17.0837 3.61845 17.0837 4.8319 17.0837L19.5652 17.0837C20.7787 17.0837 21.3854 17.0837 21.8489 16.8475C22.2566 16.6398 22.588 16.3083 22.7958 15.9006C23.0319 15.4372 23.0319 14.8304 23.0319 13.617V5.38366C23.0319 4.17021 23.0319 3.56349 22.7958 3.10001C22.588 2.69233 22.2566 2.36087 21.8489 2.15315C21.3854 1.91699 20.7787 1.91699 19.5652 1.91699L4.8319 1.91699C3.61845 1.91699 3.01173 1.91699 2.54826 2.15314C2.14057 2.36087 1.80911 2.69233 1.60139 3.10001C1.36523 3.56349 1.36523 4.17021 1.36523 5.38366Z"
          stroke="currentColor"
          strokeOpacity="0.64"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Icon>
  )
}
